/**
 * Created by vladislav on 25.01.2022
 */

cleverapps.overrideStyles(cleverapps.styles.Decorators, {
    "xmas_window_right_bottom": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window,
        animation: "down_right",
        x: { align: "right", dx: 14 },
        y: { align: "bottom", dy: -10 },
        lovesBackground: true
    },

    "xmas_window_left_top": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window_title,
        animation: "left",
        x: { align: "left", dx: -79 },
        y: { align: "top", dy: 25 },
        lovesBackground: true
    },

    "xmas_window_snowfall": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window_snowfall,
        animation: "animation",
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        zOrder: -1,
        lovesWindow: true
    },

    "halloween_window_candle_right": {
        image: bundles.windows.frames.candle_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: -125 },
        y: { align: "top", dy: 120 },
        lovesBackground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_left": {
        image: bundles.windows.frames.lian_down_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: 60 },
        y: { align: "bottom", dy: -98 },
        lovesBackground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_top": {
        image: bundles.windows.frames.lian_left_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: 86 },
        y: { align: "top", dy: 69 },
        lovesBackground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_bottom": {
        image: bundles.windows.frames.lian_right_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: 94 },
        y: { align: "bottom", dy: -40 },
        lovesBackground: true,
        scale: {
            x: 1,
            y: 1
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SceneDecors, {
    xmas_menubar: {
        image: bundles.menubar.frames.xmas_menubar,
        x: { align: "left", dx: 25 },
        y: { align: "top", dy: 17 }
    }
});
